import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
    return twMerge(clsx(inputs));
}

export function convertToArrayOfObjects(array) {
    return array.map(item => {
        return {code: item, name: item};
    });
}